import type { User } from '@omnia/shared';
import { Dock } from './Dock.tsx';
import { StartMenu } from './StartMenu.tsx';

/** The bottom row: the Omnia button at the left edge and the dock centred; it floats over the desk and takes no height from it. */
export function Taskbar({ user }: { user: User }) {
  return (
    <div className="taskbar">
      <StartMenu user={user} />
      <Dock />
      <span className="taskbar-spacer" aria-hidden />
    </div>
  );
}
